import { Country } from '@ve/types';
import { BackboneCountriesRepository } from '@ve/types/backboneModels/Domain/Repository';
import ProcessResortsAdapter from '@ve/pages/serp/adapters/ProcessResortsAdapter';

export default function (countries: BackboneCountriesRepository | null): Country[] {
    if (!countries) return [];
    return countries.map((country) => ({
        id: country.get('id'),
        name: country.get('name'),
        isPopular: country.get('isPopular'),
        position: country.get('position'),
        visaOnline: Boolean(country.get('visaOnline')),
        visaRequired: Boolean(country.get('visaRequired')),
        visaDays: country.get('visaDays'),
        minPrice: country.get('minPrice'),
        nameEng: country.get('nameEng'),
        resorts: ProcessResortsAdapter(country.get('resorts')),
    }));
}